import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { H3 } from 'foundations-components/transitional/components/H3';
import PracticalExerciseResubmitButtonContainer from './PracticalExerciseResubmitButtonContainer';
import PracticalExerciseRetryButtonContainer from './PracticalExerciseRetryButtonContainer';
import PracticalExerciseCondensedWrapper from './PracticalExerciseCondensedWrapper';
import PracticalExerciseProgressFeedback from './PracticalExerciseProgressFeedback';
import { useLoadPracticalExerciseSurvey } from '../practicalExerciseHooks';
import { useIsSimulationExercise } from '../practicalExerciseQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InReviewPracticalExerciseCondensed = ({
  advanceToNextContent,
  isManual,
  onResubmitClick,
  title,
  isPassRequiredForCert,
  resubmitType,
  contentId,
  trackId,
  lessonId
}) => {
  const {
    isSimulationExercise
  } = useIsSimulationExercise(Number(contentId), trackId);
  useLoadPracticalExerciseSurvey({
    skip: !isSimulationExercise
  });
  return /*#__PURE__*/_jsx(PracticalExerciseCondensedWrapper, {
    buttons: /*#__PURE__*/_jsxs(_Fragment, {
      children: [resubmitType === 'resubmit' ? /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(PracticalExerciseResubmitButtonContainer, {
          "data-test-id": "practical-exercise-resubmit-button",
          exerciseName: title,
          onConfirm: onResubmitClick
        })
      }) : /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, {
          contentId: contentId,
          lessonId: lessonId,
          trackId: trackId
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: advanceToNextContent,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.continue"
        })
      })]
    }),
    children: /*#__PURE__*/_jsxs(PracticalExerciseProgressFeedback, {
      "data-test-id": "in-review-practical-exercise-condensed",
      illustrationName: "errors/hourglass",
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.statusTitle.submitted",
          options: {
            exerciseName: title
          }
        })
      }), isManual ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.statusSubtitle.submitted"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.auto.subtitle"
      }), !!isPassRequiredForCert && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.auto.continue"
          })
        })
      })]
    })
  });
};
export default InReviewPracticalExerciseCondensed;